import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import usePage from "../../../../contexts/menu/MenuConsumer";
import Page from "../../../ui/Page/Page";
import Header from "../../../ui/Header/Header";
import Text from "../../../ui/Text/Text";
import img009 from "../../../../assets/images/009.jpg";
import ApiContext from "../../../../contexts/api/ApiContext";
import ApiPage from "../../../ui/ApiPage/ApiPage";

const Duo: React.FC = () => {
    usePage("duo");
    const { t } = useTranslation("duo");
    const { pageDuo } = useContext(ApiContext);

    return (
        <Page>
            <Header img="011" />
            <Text
                landscape
                rightImg={{
                    src: img009,
                    alt: t("duo-picture"),
                }}
            >
                <ApiPage data={pageDuo} />
            </Text>
        </Page>
    );
};

export default Duo;
